import { cva } from 'class-variance-authority';

export const cvaCardSwitcher = cva([
  'CardSwitcherStyles-cvaCardSwitcher',
  'bg-cDarkGray',
  'rounded-[0.8rem]',
  'overflow-clip',
]);
